import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearUser } from "../../features/user/userSlice";
import { toast } from "../../components/Common/Toast";
import { getSocket, disconnectSocket } from "../../utils/socket";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const { userInfo } = useSelector((state) => state.user);
  const isLoggedIn = !!userInfo;

  const handleLogout = () => {
    const socket = getSocket();

    if (socket && socket.connected) {
      const userId = userInfo?.id || userInfo?.user_id;
      socket.emit("userOffline", { userId });
    }

    disconnectSocket();
    dispatch(clearUser());
    setIsDropdownOpen(false);
    navigate("/");
    toast.success("Logged out successfully!");
  };

  return (
    <nav id="nav">
      <Link className="logo" to="/">
        Future<span>Soulmates</span>™
      </Link>

      <div className="nav-links">
        <NavLink to="/" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          Home
        </NavLink>

        <NavLink to="/thescience" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          The Science
        </NavLink>

        <NavLink to="/dnacompatibility" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          DNA Compatibility
        </NavLink>

        <NavLink to="/familyplanning" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          Family Planning
        </NavLink>

        <NavLink to="/enterpriseapi" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          Enterprise API
        </NavLink>

        <NavLink to="/investors" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
          Investors
        </NavLink>
      </div>

      {isLoggedIn ? (
        <div className="user-dropdown">
          <button
            className="nav-btn"
            type="button"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            Hi, {userInfo?.first_name || "User"} {isDropdownOpen ? "▲" : "▼"}
          </button>

          {isDropdownOpen && (
            <div className="dropdown-menu-custom">
              <button
                type="button"
                onClick={() =>
                  navigate("/dashboard", { state: { activtab: "dash" } })
                }
              >
                Dashboard
              </button>

              <button
                type="button"
                onClick={() =>
                  navigate("/dashboard", { state: { activtab: "settings" } })
                }
              >
                Setting
              </button>

              <button type="button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      ) : (
        <Link to="/login" className="nav-btn">
          Login
        </Link>
      )}
    </nav>
  );
};

export default Header;
// import React, { useState } from "react";
// import { Link, NavLink, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { clearUser } from "../../features/user/userSlice";
// import { toast } from "../../components/Common/Toast";
// import { getSocket, disconnectSocket } from "../../utils/socket";

// const Header = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [isNavOpen, setIsNavOpen] = useState(false);
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//   const { userInfo } = useSelector((state) => state.user);
//   const isLoggedIn = !!userInfo;

//   const handleLogout = () => {
//     const socket = getSocket();

//     if (socket && socket.connected) {
//       const userId = userInfo?.id || userInfo?.user_id;
//       socket.emit("userOffline", { userId });
//     }

//     disconnectSocket();
//     dispatch(clearUser());
//     setIsDropdownOpen(false);
//     navigate("/");
//     toast.success("Logged out successfully!");
//   };

//   return (
//     <header className="header mainheader">
//       <nav id="nav" className="custom-nav">
//         <div className="nav-left">
//           <button
//             className="mobile-menu-btn"
//             onClick={() => setIsNavOpen(!isNavOpen)}
//           >
//             ☰
//           </button>

//           <div className={`nav-links ${isNavOpen ? "show" : ""}`}>
//             <NavLink to="/" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               Home
//             </NavLink>

//             <NavLink to="/science" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               The Science
//             </NavLink>

//             <NavLink to="/dna" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               DNA Compatibility
//             </NavLink>
//           </div>
//         </div>

//         <Link to="/" className="logo nav-logo-center">
//           Future<span>Soulmates</span>™
//         </Link>

//         <div className="nav-right">
//           <div className={`nav-links ${isNavOpen ? "show" : ""}`}>
//             <NavLink to="/family" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               Family Planning
//             </NavLink>

//             <NavLink to="/enterprise" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               Enterprise API
//             </NavLink>

//             <NavLink to="/investor" className={({ isActive }) => `nl ${isActive ? "on" : ""}`}>
//               Investors
//             </NavLink>
//           </div>

//           {isLoggedIn ? (
//             <div className="user-dropdown">
//               <button
//                 className="nav-btn"
//                 onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//               >
//                 Hi, {userInfo?.first_name || "User"} {isDropdownOpen ? "▲" : "▼"}
//               </button>

//               {isDropdownOpen && (
//                 <div className="dropdown-menu-custom">
//                   <button onClick={() => navigate("/dashboard", { state: { activtab: "dash" } })}>
//                     Dashboard
//                   </button>

//                   <button onClick={() => navigate("/dashboard", { state: { activtab: "settings" } })}>
//                     Setting
//                   </button>

//                   <button onClick={handleLogout}>Logout</button>
//                 </div>
//               )}
//             </div>
//           ) : (
//             <Link to="/login" className="nav-btn">
//               Login
//             </Link>
//           )}
//         </div>
//       </nav>
//     </header>
//   );
// };

// export default Header;